import { Student } from '../types'

export const s1KelasA: Student[] = [
  { nim: '2405402', name: 'Jeany Putrie Widyautami' },
  { nim: '2400042', name: 'Yolla Laifi Ananda' },
  { nim: '2400115', name: 'Alby Aditya Putra Wibawa' },
  { nim: '2400227', name: 'Khansa Nisrina Awalia' },
  { nim: '2400232', name: 'Hasya Fazati' },
  { nim: '2400675', name: 'Zhafira Azka Dudy' },
  { nim: '2400700', name: 'Naylla Fahhad' },
  { nim: '2400725', name: 'Sulastri Rizqi Apriliani' },
  { nim: '2401191', name: 'Nadiya Devinda' },
  { nim: '2401274', name: 'Ivana Maria Tiara Taruli Butarbutar' },
  { nim: '2401448', name: 'Agami Ramadhani' },
  { nim: '2402185', name: 'Nadia Alifia' },
  { nim: '2403411', name: 'Hasna Azzahiyah Suherman' },
  { nim: '2403434', name: 'Rizka Aziemah Akhyar' },
  { nim: '2403554', name: 'Dzakira Nida Galuh Shopiana' },
  { nim: '2403628', name: 'Syakira Nafila Yasmin' },
  { nim: '2403721', name: 'Sugih Fitriani' },
  { nim: '2403928', name: 'Silvia Adzhani Fadhilah' },
  { nim: '2403998', name: 'Rahmah Salsabila Putri' },
  { nim: '2404292', name: 'Jasminda Kayla Maudina' },
  { nim: '2404429', name: 'Fakhira Khairani Handoko' },
  { nim: '2404555', name: 'Aisyah Zahidah Rabbani' },
  { nim: '2404693', name: 'Syahida Nurul Ashila Rusdiana' },
  { nim: '2404725', name: 'Haidar Ryan Mustafa' },
  { nim: '2405232', name: 'Az-Zahra Awwalu An-Nisa Pramuji' },
  { nim: '2405329', name: 'Aena Nissa Fajri Awaliah' },
  { nim: '2405391', name: 'Ratu Insan Fadhilah' },
  { nim: '2400034', name: 'Najwa Ineza' },
  { nim: '2406405', name: 'Felicia Rizky Naulita' },
  { nim: '2406410', name: 'Windy Lameria Simanullang' },
  { nim: '2406490', name: 'Lyra Camelia' },
  { nim: '2406923', name: 'Sultami Aulia Putri' },
  { nim: '2406995', name: 'Putri Carliah Maulidah' },
  { nim: '2407054', name: 'Haikal Apriansyah' },
  { nim: '2407063', name: 'Alda Gresela Aritonang' },
  { nim: '2407252', name: 'Atikah' },
  { nim: '2407615', name: "Afif Uzain Asy'Ari" },
  { nim: '2407657', name: 'Alya Kamilia Agustin' },
  { nim: '2407682', name: 'Nadhilah Azfa Khairina' },
  { nim: '2407869', name: 'Zulfa Najwa Zaen' },
  { nim: '2408049', name: 'Hanifa Ramadhani' },
  { nim: '2408082', name: 'Nurul Aini Putri Isnawan' },
  { nim: '2408502', name: 'Annisa Almaas Quraru Aini' },
  { nim: '2408528', name: 'Aulya Khansa Iswahyudi' },
  { nim: '2408561', name: 'Gilbert Kaizen' },
  { nim: '2408777', name: 'Fiska Dhiyaul Auliyah' },
  { nim: '2409300', name: 'Mohammad Mahri Naelul Marom' },
  { nim: '2410243', name: 'Maisya Nurul Amalyah' },
  { nim: '2410721', name: 'Chiko Simanjorang' },
  { nim: '2411343', name: 'Nabila Rahmah Khoirunnisa' }
]

export const s1KelasB: Student[] = [
  { nim: '2400751', name: 'Meita Sulistiyo' },
  { nim: '2400473', name: 'Aura Julia Agustin' },
  { nim: '2400418', name: 'Anerfa Keisya Alifia' },
  { nim: '2400872', name: 'Ghania Nur Fatharani' },
  { nim: '2401071', name: 'Dhea Siti Adila' },
  { nim: '2401189', name: 'Deswita Faradhillah' },
  { nim: '2401253', name: 'Khoiriyah Isnaini F.P.' },
  { nim: '2401610', name: 'Madita Putri Utami' },
  { nim: '2401701', name: 'Rasya Zahra Aurellia' },
  { nim: '2401833', name: 'Nayla Farlah A.' },
  { nim: '2402036', name: 'Rembualan Eryani G' },
  { nim: '2402116', name: 'Astrid Frycilea Johanes' },
  { nim: '2402145', name: 'Kaisya Zahda Ayman' },
  { nim: '2402335', name: 'Rifaldini' },
  { nim: '2402636', name: 'Susilawati' },
  { nim: '2403458', name: 'Shabrina Fauzia Zahra' },
  { nim: '2403473', name: 'Nisrina Nurul Hadi' },
  { nim: '2403729', name: 'Nisrina Nur Aulia P.F' },
  { nim: '2403869', name: 'Mutia Latifah' },
  { nim: '2403900', name: 'Dhiaulhaq Najmuddin Naufal' },
  { nim: '2404053', name: 'Siti Auliya Ramadhani' },
  { nim: '2404214', name: 'Fauzah Tasyah Junita' },
  { nim: '2404592', name: 'Balqis Amalina' },
  { nim: '2404680', name: 'Faras Zahwa Alika' },
  { nim: '2404793', name: 'Anindya Rahmadyanti' },
  { nim: '2404999', name: 'Siti Hasna Nur Aziah' },
  { nim: '2405513', name: 'Regina Putri Herlina' },
  { nim: '2405574', name: 'Thalita Hunafa A.' },
  { nim: '2405649', name: 'Najla Raisa Maharani' },
  { nim: '2406569', name: 'Hantika Melistianti' },
  { nim: '2406829', name: 'Nabila Permana Putri' },
  { nim: '2407175', name: 'Silvi Anugrah W' },
  { nim: '2407362', name: 'Devitasari' },
  { nim: '2407840', name: 'Widya Salma Kusmana' },
  { nim: '2407926', name: 'Zalfa Imtinan' },
  { nim: '2407978', name: 'Annisa Nurul Aini' },
  { nim: '2408070', name: 'Ririn Arifa Mutaqin' },
  { nim: '2408093', name: 'Sri Nurhayati' },
  { nim: '2408307', name: 'Destri Novianti' },
  { nim: '2408341', name: 'Alvi Mauladani Fauzi' },
  { nim: '2408371', name: 'Naila A. Amatillah' },
  { nim: '2408887', name: 'Zainul Hayfillah' },
  { nim: '2409044', name: 'Putri Jasmine I.' },
  { nim: '2409153', name: 'Resi Hiskawiyah S.W' },
  { nim: '2409216', name: 'Nada Aristawidya P' },
  { nim: '2409282', name: 'Nazwa Azizah' },
  { nim: '2409288', name: 'Fadya Hilwi' },
  { nim: '2410011', name: 'Waliya Rachmatun N.' },
  { nim: '2410036', name: 'Nadzwa Putri Ananta' },
  { nim: '2410377', name: 'Cherry Noor Rizkia' },
  { nim: '2410534', name: 'Luisha Amanda P.E.' },
  { nim: '2411335', name: 'Rizka Ayu Sofiani' },
  { nim: '2411336', name: 'Normalasari' },
  { nim: '2411340', name: 'Wafa Nurul Fauziah' }
]

export const s2: Student[] = [
  { nim: '2520867', name: "A'Zhamul Adna Diamanthly" },
  { nim: '2520873', name: 'Naniek Murni Astuti' },
  { nim: '2520927', name: 'Aulia Wasilah Fathonah Salim' },
  { nim: '2520956', name: 'Kania Sajida' },
  { nim: '2521010', name: 'Anissa Sekar Putri' },
  { nim: '2521020', name: 'Widianti Eliza' },
  { nim: '2521066', name: 'Nanda Eka Yusfira' },
  { nim: '2521101', name: 'Rahmat Siala' },
  { nim: '2521129', name: 'Nurul Khoiiriyah Panjaitan' },
  { nim: '2521181', name: 'Zulfa Luthfiah Fauzi' },
  { nim: '2521183', name: 'Astri Asih Labibah' },
  { nim: '2521225', name: 'Wina Aulya Munawar' },
  { nim: '2521272', name: 'Yushini Hasya Nuha' },
  { nim: '2521344', name: 'Andini Rifa Saniyah Baharuddin' },
  { nim: '2521351', name: 'Alifia Rizki Farhani' },
  { nim: '2521356', name: 'Chika Adhani Suid' },
  { nim: '2521374', name: 'Vebri Muliani' },
  { nim: '2521430', name: 'Filia Srikandi M Harefa' },
  { nim: '2521654', name: 'Olivia E. Fallo' },
  { nim: '2521655', name: 'Eli Apriyaningsih' },
  { nim: '2521660', name: 'Zeffa Yurihana' },
  { nim: '2521753', name: 'Delvira Nur Anbiya' },
  { nim: '2522375', name: 'Fairuz Rizka Ghazalah' },
  { nim: '2522441', name: 'Fatia Wina Ramadhan' }
]
